var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"wizard-wrapper",attrs:{"data-type":_vm.type}},[(_vm.isHeader)?[_c('div',{staticClass:"wizard-header-glow",style:(_vm.glowStyles)})]:_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }